<ng-container *ngIf="{ entriesCount: (entriesCount$ | async) } as vm">
  <a
    class="px-6 py-6 w-100 h-100 flex items-center cursor-pointer"
    (click)="toggle()"
    (keyup.enter)="toggle()"
    pRipple
  >
    <span class="p-overlay-badge layout-topbar-item__menuIcon">
      <i
        class="!text-xl {{ counter.icon.name | getIconCssClass }}"
        [ngClass]="{ 'notification-badge--active': overlayVisible }"
      >
        <p-badge
          data-testId="notification-count"
          *ngIf="vm.entriesCount as count"
          [class.hidden]="count <= 0"
          [title]="count"
          [value]="count < 100 ? count.toString() : '99+'"
          styleClass="p-badge-sm notification-badge"
        ></p-badge>
      </i>
    </span>
  </a>
  <p-overlay
    [(visible)]="overlayVisible"
    *ngIf="overlayVisible"
    contentStyleClass="notification-menu"
  >
    <ng-container *ngTemplateOutlet="notificationCounter"></ng-container>
  </p-overlay>

  <ng-template #notificationCounter>
    <div class="layout-topbar-action-panel notification-menu">
      <app-notification-counter-menu
        [counter]="counter"
        [entriesCount]="vm.entriesCount"
        (closeMenu)="toggle()"
      ></app-notification-counter-menu>
    </div>
  </ng-template>
</ng-container>
